import '@f-fertighaus/layout/PageHeader/SSR/PageHeaderSSR'
import '@f/components/PageSharing'
import '@js/common/site-wide'
import '@js/common/request-flow-triggers'
import '@f-fertighaus/widgets/FloatingBanner'

import debounce from 'lodash.debounce'
import { createRoot } from 'react-dom/client'

import FinanceEntry from '@f-fertighaus/applications/FinanceEntry'

/* Dynamic scrollable tables */
void (function () {
  let tables = [...document.querySelectorAll('.table table')]

  tables.map(table => {
    let checkTable = () => {
      if (table.scrollWidth > table.offsetWidth) {
        table.parentNode.parentNode.classList.add('has-scroll')
      } else {
        table.parentNode.parentNode.classList.remove('has-scroll')
      }
    }

    checkTable()

    window.addEventListener('resize', () => {
      checkTable()
    })
  })
})()

// Render Finance Funnel Entry
let financeFunnelAnchors = document.querySelectorAll('.js-finance-entry')

for (const anchor of financeFunnelAnchors) {
  const root = createRoot(anchor)
  root.render(<FinanceEntry type='tile' />)
}

// Category Overview Breadcrumbs
void (function () {
  let checkCategoriesToggle = () => {
    let categoriesBar = document.querySelector('.js-check-toggle')
    let categoryItems = [
      ...categoriesBar.querySelectorAll(
        '.cms-categories .js-cms-categories-item'
      )
    ]
    let hiddenCategoriesContainer = document.querySelector(
      '.js-cms-hidden-categories'
    )
    let hiddenCategories = []
    let showToggle = false

    categoryItems.reduce((acc, current, index) => {
      /* First element will set the first lines' top value */
      if (index === 0) {
        return current.getBoundingClientRect().top
      }
      if (acc !== current.getBoundingClientRect().top) {
        showToggle = true
        hiddenCategories.push(current)
        return 0
      }
      return acc
    }, 0)

    if (showToggle) {
      categoriesBar.classList.remove('hide-toggle')
    } else {
      hiddenCategories = []
      categoriesBar.classList.add('hide-toggle')
    }

    while (hiddenCategoriesContainer.firstChild) {
      hiddenCategoriesContainer.removeChild(
        hiddenCategoriesContainer.firstChild
      )
    }

    if (hiddenCategories.length > 0) {
      hiddenCategories.map(element => {
        hiddenCategoriesContainer.appendChild(element.cloneNode(true))
      })
    }
  }

  checkCategoriesToggle()

  window.addEventListener('resize', debounce(checkCategoriesToggle, 400))
})()
